import { Button } from '@/atoms/Button'
import { AgencyStatusPill } from '@/modules/agencies/components/AgencyStatusPill'
import type { Agency } from '@/modules/agencies/types/agency'
import type { AgencyStatusAction } from '@/modules/agencies/utils/agencyStatusAction'
import { getAgencyStatusTone } from '@/modules/agencies/utils/agencyStatusTone'

export type AgencyDetailHeaderProps = {
  agency: Agency
  statusAction: AgencyStatusAction | null
  isStatusPending: boolean
  onBack: () => void
  onEdit: () => void
  onStatusAction: () => void
}

export function AgencyDetailHeader({
  agency,
  statusAction,
  isStatusPending,
  onBack,
  onEdit,
  onStatusAction,
}: AgencyDetailHeaderProps) {
  const statusButtonLabel =
    statusAction === 'suspend'
      ? 'Suspend agency'
      : statusAction === 'activate'
        ? 'Activate agency'
        : null

  return (
    <div className="flex flex-wrap items-start justify-between gap-4 border-b-2 border-ink pb-5">
      <div className="flex flex-col gap-3">
        <Button type="button" variant="ghost" onClick={onBack} className="w-fit">
          ← Back to agencies
        </Button>
        <div>
          <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted">
            Agency detail
          </p>
          <h1 className="mt-2 font-display text-3xl font-medium tracking-[-0.02em] text-ink">
            {agency.name}
          </h1>
          <p className="mt-1 font-mono text-sm text-muted">{agency.slug}</p>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <AgencyStatusPill
          status={agency.status}
          tone={getAgencyStatusTone(agency.status)}
        />
        <Button type="button" onClick={onEdit} disabled={isStatusPending}>
          Edit agency
        </Button>
        {statusButtonLabel ? (
          <Button
            type="button"
            variant="ghost"
            disabled={isStatusPending}
            onClick={onStatusAction}
            className={
              statusAction === 'suspend'
                ? 'border-accent text-accent hover:bg-accent-soft'
                : undefined
            }
          >
            {statusButtonLabel}
          </Button>
        ) : null}
      </div>
    </div>
  )
}
